// Hızlı Stok Kaydı penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.quickAdd';

export const inventoryQuickAddGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Hızlı stok kaydı nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, tam stok kartını doldurmadan yalnız temel bilgilerle yeni ürün açmanızı sağlar. Tek ürün için "Tekli", aynı anda 10 ürüne kadar "Toplu" sekmesini kullanın.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Tekli / Toplu sekmeleri'),
    body: t(`${G}.regions.body`, 'Ürün bilgileri'),
    footer: t(`${G}.regions.footer`, 'Tam karta geç / Kaydet'),
  },
  navItems: [
    t(`${G}.nav.single`, 'Hızlı Stok Kaydı (Tekli)'),
    t(`${G}.nav.bulk`, 'Toplu Hızlı Stok Kaydı'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sekmeyi seçin'),
      text: t(`${G}.s1.text`, '"Hızlı Stok Kaydı (Tekli)" tek ürün için daha çok alan sunar. "Toplu Hızlı Stok Kaydı" ile ortak depo ve KDV bilgileriyle 10 ürüne kadar tek seferde kayıt açılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tekli: zorunlu alanlar'),
      text: t(`${G}.s2.text`, '"Ürün Adı", "Satış Fiyatı" ve "KDV Oranı" zorunludur. Barkod boş bırakılırsa otomatik üretilir; stok kodu her zaman ürün adının ilk 3 harfi ve rastgele 4 haneli bir sayıyla otomatik verilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Hızlı satışta okutulup bulunamayan bir barkodla açıldıysa barkod alanı dolu gelir; böylece bir sonraki okutmada ürün bulunur.'),
        t(`${G}.s2.tip2`, 'Alış fiyatı, birim ve kategori isteğe bağlıdır (birim varsayılan "adet").'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Fiyat, KDV ve departman'),
      text: t(`${G}.s3.text`, '"KDV Durumu" girdiğiniz satış fiyatının KDV Dahil mi KDV Hariç mi olduğunu belirtir (varsayılan KDV Hariç, oran %20). "Departman No (ÖKC)" yazar kasa departmanıdır; 1 ile 10 arasında olmalıdır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Stok eksiye düşebilir" işaretliyse ürün stokta yokken de satılabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Başlangıç stoğu ve depo'),
      text: t(`${G}.s4.text`, '"Stok Adeti" isteğe bağlıdır; girilirse ürün kaydedildikten sonra bu miktar seçilen depoya eklenir. Miktar girdiyseniz depo seçimi zorunludur. Varsayılan depo otomatik seçilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Toplu kayıt'),
      text: t(`${G}.s5.text`, 'Üstte "Ortak Depo" (zorunlu), "Ortak KDV Oranı" (zorunlu), "Ortak KDV Durumu", "Ortak Departman No" ve "Stok eksiye düşebilir (Tümü için)" bütün satırlara uygulanır. Altındaki 10 satıra ürün adı, satış fiyatı, stok adeti ve isteğe bağlı barkod yazın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Yalnız ürün adı, satış fiyatı ve miktarı dolu satırlar kaydedilir; boş satırlar atlanır. Toplu kayıtta birim "adet" olur.'),
        t(`${G}.s5.tip2`, 'Kayıt sırasında bir ürün hata verirse işlem durur; o ana kadar kaydedilen ürünler kayıtlı kalır ve kaç ürünün kaydedildiği yazılır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin veya tam karta geçin'),
      text: t(`${G}.s6.text`, '"Hızlı Kaydet" / "Tümünü Hızlı Kaydet" zorunlu alanlar dolunca açılır; kayıt başarılı olunca pencere kapanır. "İptal" ya da X pencereyi girdiğiniz bilgileri silmeden kapatır.'),
      tips: [
        t(`${G}.s6.tip1`, '"Tam karta geç →" (yalnız Tekli sekmede, ekran destekliyorsa) girdiğiniz ad, barkod, birim, KDV, fiyatlar, kategori ve departmanı tam stok kartına taşır. Stok adeti ve depo taşınmaz.'),
      ],
    },
  ],
});
